export default __webpack_public_path__ + "static/media/message-overlay-mobile.7584abc8.png";